export default "__VITE_ASSET__2161c548__"